module.exports = __webpack_public_path__ + "static/media/S (20).0f97ed04.jpg";